import { graphql } from 'react-apollo';
import { graphql as kbGraphQL, utils } from 'kb-shared';
import Appointments from '../screens/Appointments';

const { inFuture } = utils;

const withAppointments = graphql(kbGraphQL.query.PATIENT_APPOINTMENTS, {
  props: ({ data }) => ({
    scheduledAppointments:
      // @ts-ignore
      data && data.appointments && data.appointments.filter(appt => inFuture(appt.startTime)),
    pastAppointments:
      // @ts-ignore
      data && data.appointments && data.appointments.filter(appt => !inFuture(appt.startTime))
  })
});

// @ts-ignore
const connectedAppointments = withAppointments(Appointments);

export default connectedAppointments;
